import { useMemo } from 'react';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import { useStrapiGlobal } from '@/context';
import type { QuickAccess } from '@/interfaces/strapi';

type FooterTopProps = {
	readonly className?: string;
};

const classNameComponent = 'c-cnm-footer__top';

export const FooterTop = ({ className }: FooterTopProps) => {
	const wrapperClassName = useMemo(() => classNames(classNameComponent, className), [className]);
	const { layout } = useStrapiGlobal();
	const { footer } = layout;
	const { top } = footer;
	const { quickAccess } = top;
	return (
		<section className={wrapperClassName}>
			<div className="o-container">
				<div className={`${classNameComponent}-content`}>
					<h3 className={`${classNameComponent}-title`}>{top.title}</h3>

					<ul className={`${classNameComponent}-list ${classNameComponent}-list--columns`}>
						{quickAccess.map((it: QuickAccess) => (
							<li key={it.text} className={`${classNameComponent}-list-item`}>
								<Link to={it.url}>
									<img src={it.icon.url} />
									<span>{it.text}</span>
								</Link>
							</li>
						))}
					</ul>
				</div>
			</div>
		</section>
	);
};
